import React from 'react'
import { Form } from 'react-bootstrap'
import { Tooltip } from '../Tooltip/Tooltip'

export interface IntegrationUrlInputFieldProps {
  label: string
  tooltipText: string
  value: string | null
  onChange: (value: string) => void
  placeholder: string
  helperText: string
  disabled?: boolean
  error?: string
}

export const IntegrationUrlInputField: React.FC<IntegrationUrlInputFieldProps> = ({
  label,
  tooltipText,
  value,
  onChange,
  placeholder,
  helperText,
  disabled = false,
  error,
}) => {
  const fieldId = React.useId()
  const errorId = `${fieldId}-error`

  return (
    <Form.Group controlId={fieldId}>
      <Form.Label className='label-medium'>
        {label}&nbsp;
        <Tooltip className='zocks-text-gray-500' placement='right' title={tooltipText}>
          <i className='bi bi-info-circle' />
        </Tooltip>
      </Form.Label>
      <Form.Control
        className='mt-1'
        value={value || ''}
        onChange={(e) => onChange(e.currentTarget.value)}
        placeholder={placeholder}
        disabled={disabled}
        isInvalid={!!error}
        aria-describedby={error ? errorId : undefined}
      />
      <Form.Control.Feedback id={errorId} type='invalid'>
        {error}
      </Form.Control.Feedback>
      <Form.Text className='text-muted'>{helperText}</Form.Text>
    </Form.Group>
  )
}
